import React from 'react'
import {
  Loader as LoaderCircle,
  LoaderProps as LoaderCircleProps,
} from '@mantine/core'
import styled from '@emotion/styled'

interface LoaderProps extends LoaderCircleProps {
  size?: 'sm'
}

const Loader = ({ size, ...rest }: LoaderProps) => {
  const StyledBox = styled(`div`)(() => ({
    display: `flex`,
    minHeight: size === `sm` ? `auto` : `100vh`,
    alignItems: `center`,
    justifyContent: `center`,
  }))

  return (
    <StyledBox>
      <LoaderCircle {...rest} />
    </StyledBox>
  )
}

export default Loader
